import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

/**
 *
 * @param date Date in string (i.e. 2022-03-23), should be UTC+0
 * @param utc  Set to true if you want to transform your date to UTC+0
 * @returns Dayjs date
 */

export const utcDateToLocalTimezone: (date: string) => dayjs.Dayjs = (date) => {
    const timezone = dayjs.tz.guess();
    return dayjs.utc(date).tz(timezone);
};

/**
 * Converts a UTC date string to local time and returns a human-readable relative time string
 * @param utcDateString Date string in UTC format (e.g., "2022-03-23T10:30:00Z")
 * @returns Human-readable relative time string (e.g., "2 hours ago", "3 days ago", "2 weeks ago")
 */
export const timeToNow = (utcDateString: string): string => {
    const localDate = utcDateToLocalTimezone(utcDateString);
    const now = dayjs();

    const diffInMinutes = now.diff(localDate, 'minute');
    const diffInHours = now.diff(localDate, 'hour');
    const diffInDays = now.diff(localDate, 'day');
    const diffInWeeks = now.diff(localDate, 'week');
    const diffInMonths = now.diff(localDate, 'month');
    const diffInYears = now.diff(localDate, 'year');

    if (diffInMinutes < 1) {
        return 'now';
    } else if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
    } else if (diffInDays < 7) {
        return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
    } else if (diffInWeeks < 4) {
        return `${diffInWeeks} week${diffInWeeks !== 1 ? 's' : ''} ago`;
    } else if (diffInMonths < 12) {
        return `${diffInMonths} month${diffInMonths !== 1 ? 's' : ''} ago`;
    } else {
        return `${diffInYears} year${diffInYears !== 1 ? 's' : ''} ago`;
    }
};
